import { render, staticRenderFns } from "./FieldTypeSelect.vue?vue&type=template&id=0084e857&scoped=true"
import script from "./FieldTypeSelect.vue?vue&type=script&lang=js"
export * from "./FieldTypeSelect.vue?vue&type=script&lang=js"
import style0 from "./FieldTypeSelect.vue?vue&type=style&index=0&id=0084e857&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0084e857",
  null
  
)

export default component.exports